import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import { useTranslation } from "react-i18next";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import Notification from "../notification/Notification";
import { parseAxiosError } from "../../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../../utils/consts";

const DocumentVerificationSchemaSelect = ({ checkedDocumentFlow, setCheckedDocumentFlow, defaultOption = false }) => {
  const { t } = useTranslation("otherInterface");

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [verificationSchemas, setVerificationSchemas] = useState([]);

  const fetchVerificationSchemas = () => {
    axios.get("/api/verification-schemas", userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setVerificationSchemas(response.data["hydra:member"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchVerificationSchemas();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <FormControl>
        <Autocomplete
          options={verificationSchemas.map((verificationSchema) => verificationSchema.name) || []}
          value={checkedDocumentFlow || null}
          onChange={(event, checkedDocumentFlow) => setCheckedDocumentFlow(checkedDocumentFlow)}
          renderInput={(params) => (
            <TextField {...params} label={t("documentFlowSelect.title")} />
          )}
          blurOnSelect
          disableClearable={!defaultOption}
        />
      </FormControl>
    </>
  );
};

export default DocumentVerificationSchemaSelect;